// extracted by mini-css-extract-plugin
export default {"app":"NoticeBarMobile_app__YDbsr","time":"NoticeBarMobile_time__kZRC8","button":"NoticeBarMobile_button__-LOmF"};